import React from 'react'
import Loader from 'react-loader-spinner'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

let visible = false;

export function setVisible(val){
    visible=val;
}

export default function Spinner() {
    return (
        <Loader className="loader"
            type="ThreeDots"
            color="#9c1d26"
            height={100}
            width={100}
            visible={visible}
        />
    )
}


